/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { handleClick, getAllShopsPushNotification, definePushNotifTableHeads, handleRowClick } from './PushNotification.services';
import {
  TableFooter,
  Button,
  EmptyView,
  Table,
  BackButton,
  Paper
} from '../../components';
import { styles } from './PushNotification.styles';
import { isObjectNotEmpty } from '../../utils/tools';
import { marketing } from '../../constants';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/notification.svg';
import { ReactComponent as ImportedNotifSVG } from '../../assets/pictures/pushNotif.svg';
import {
  EMPTY_DESIGN_PUSH_NOTIF_TEXT,
  EMPTY_DESIGN_PUSH_NOTIF_TITLE, EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TITLE, EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TEXT
} from '../../constants/dishopInfo';
import { getDateFormat } from '../../utils/suitableDate';
import { PushNotifModal } from './PushNotificationModal'
import { Cookies } from 'react-cookie';
import { Grid } from '@material-ui/core';
import { PUSH_NOTIF_STATUS } from '../../constants/dataConfig';
import { UNIT } from '../../constants';
function PushNotification({ classes, history = {}, shopId, pushNotifications, name, openErrorModal }) {
  const [stateObj, setStateObjRaw] = useState({
    modalOpen: false,
    pushNotif: {},
    isLoadingModal: false,
    createPushNotif: false
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });
  const isAllShops = JSON.parse(new Cookies().get('isAllShops') || false);
  const pushNotifs = isAllShops ? getAllShopsPushNotification(pushNotifications) : pushNotifications?.[shopId]
  const data = pushNotifs && Object.values(pushNotifs).map(element => ({
    date: element.scheduledDate || element.date,
    cible: element.toAllUsers ? 'Tous' : name,
    title: element.title,
    message: element.message,
    scheduledDate: element.scheduledDate,
    status: element.status || '--',
    id: element.id,
    nbUsers: element.nbUsers,
    toAllUsers: element.toAllUsers

  }))


  const createTableRow = data => <TableBody>
    {data.map((e, i) => <TableRow key={i} style={{ cursor: 'pointer' }} onClick={() => handleRowClick(e, setStateObj, isAllShops)}>
      <TableCell align="center" className={classes.produits} style={{ width: UNIT * 11.625 }}>
        {getDateFormat(e.date, 'lll')}
      </TableCell>
      <TableCell align="center" className={classes.produits}>
        {e?.title || ''}
      </TableCell>
      <TableCell align="center" className={classes.produits}>
        {e.message}
      </TableCell>
      <TableCell
        align="center"
        className={classes.produits}
        style={{
          color: PUSH_NOTIF_STATUS[e.status]?.label ? `${PUSH_NOTIF_STATUS[e.status].color}` : 'inherit',
        }}
      >
        {PUSH_NOTIF_STATUS[e.status]?.label || '--'}
      </TableCell>
      <TableCell align="center" className={classes.produits}>
        {e?.nbUsers || 0}
      </TableCell>
      {!isAllShops && <TableCell align="center" className={classes.produits}>
        {e.cible}
      </TableCell>}

    </TableRow>)
    }
  </TableBody >
  return (
    <div className="p-4 ">
      <BackButton
        className="p-0 pb-3"
        onClick={() => history.goBack()}
        title={marketing.pushNotification.text}
        subtitle={marketing.pushNotification.description}
      />

      {isObjectNotEmpty(pushNotifs) ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Paper className='py-4'>
                <div className='pb-3 px-3'>
                  <EmptyView
                    className={classes.svg}
                    src={ImportedSVG}
                    title='Envoyez des notifications manuelles'
                    text={`Personnalisez l'envoi des notifications`}
                  >
                    <ButtonNotif setStateObj={setStateObj} />
                  </EmptyView>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Paper className='py-4'>
                <div className='pb-3 px-3'>
                  <EmptyView
                    className={classes.disabledSvg}
                    src={ImportedNotifSVG}
                    title={EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TITLE}
                    text={EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TEXT}
                  >
                    <Button className='btn-xs-block mx-3' onClick={() => handleClick(setStateObj, true, true)}>
                      <div className="row justify-content-center align-items-center mr-0 ml-0">
                        <AddIcon />
                        <p className="m-0 ml-1"> Créer une nouvelle Push Notification programmée</p>
                      </div>
                    </Button>
                  </EmptyView>
                </div>
              </Paper>
            </Grid>
          </Grid>
          <h4 className='py-4'>Historique des envois</h4>
          <Paper scrollOption="auto">
            <Table
              headCells={definePushNotifTableHeads(isAllShops)}
              classes={classes}
              bodyRows={data}
              createTableRow={createTableRow}
              order="desc"
              orderBy="date"
            />
          </Paper>
          <TableFooter
            rowsPerPageOptions={[5, 10, 25]}
            lengthOption={_.keys(pushNotifs).length}
          />
        </>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Paper className='py-4'>
              <div className='pb-3 px-3'>
                <EmptyView
                  className={classes.disabledSvg}
                  src={ImportedSVG}
                  title={EMPTY_DESIGN_PUSH_NOTIF_TITLE}
                  text={EMPTY_DESIGN_PUSH_NOTIF_TEXT}
                >
                  <ButtonNotif setStateObj={setStateObj} />
                </EmptyView>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Paper className='py-4'>
              <div className='pb-3 px-3'>
                <EmptyView
                  className={classes.svg}
                  src={ImportedNotifSVG}
                  title={EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TITLE}
                  text={EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TEXT}
                >
                  <Button className='btn-xs-block mx-3' onClick={() => handleClick(setStateObj, true, true)}>
                    <div className="row justify-content-center align-items-center mr-0 ml-0">
                      <AddIcon />
                      <p className="m-0 ml-1"> Créer une nouvelle Push Notification programmée</p>
                    </div>
                  </Button>
                </EmptyView>
              </div>
            </Paper>
          </Grid>
        </Grid>
      )}
      <PushNotifModal openErrorModal={openErrorModal} setStateObj={setStateObj} stateObj={stateObj} createPushNotif={stateObj.createPushNotif} />
    </div>
  );
}


function ButtonNotif({ setStateObj }) {
  return <Button className="btn-xs-block mx-3" color="primary" onClick={() => handleClick(setStateObj, true, false)}>
    <div className="row justify-content-center align-items-center mr-0 ml-0">
      <AddIcon />
      <p className="m-0 ml-1"> Créer une nouvelle Push Notification</p>
    </div>
  </Button>
}

function mapStateToProps({ user, page, firebaseRealTime }) {
  const { shop = {}, pushNotifications } = firebaseRealTime;
  const { name } = shop;
  const { shopId, shopName, nbShops } = user;
  return {
    pushNotifications,
    shop,
    nbShops,
    page,
    shopId,
    shopName,
    name
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(PushNotification)));
